import autoTable from "jspdf-autotable";

export function drawAutoTable(doc, options) {
  // Default behavior: do not split a row across pages. If a row doesn't fit, move it fully to the next page.
  // (If a single row is taller than a page, autoTable will still have to split it.)
  autoTable(doc, { rowPageBreak: "avoid", ...options });
  const finalY = doc.lastAutoTable?.finalY;
  return typeof finalY === "number" ? finalY : null;
}

export function defaultGridStyles({ fontSize = 8, cellPadding = 2 } = {}) {
  return {
    theme: "grid",
    styles: {
      fontSize,
      cellPadding,
      overflow: "linebreak",
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
      tableLineWidth: 0.5,
      tableLineColor: [0, 0, 0],
      fontStyle: "normal",
      textColor: [0, 0, 0],
    },
    headStyles: {
      fillColor: [235, 235, 235],
      textColor: [0, 0, 0],
      lineWidth: 0.5,
      lineColor: [0, 0, 0],
      fontStyle: "normal",
    },
    bodyStyles: {
      lineColor: [0, 0, 0],
      lineWidth: 0.5,
      fontStyle: "normal",
      textColor: [0, 0, 0],
    },
  };
}


